import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-auth-card',
  templateUrl: './auth-card.component.html',
  styleUrls: ['../styles/auth.scss', './auth-card.component.scss'],
  standalone: false,
})
export class AuthCardComponent {
  @Input() size: 'small' | 'large' | 'full' = 'small';
  @Input() loading = false;
  @Input() progress = false;

  get env() {
    return environment;
  }
}
